import Utils3D from 'shared/libraries/mwc/3d/utils/utils3D';
import Node from '../node.js';
import Utils from '../utils.js';
import { PARAM_TYPE } from '../connector.js';
import CoreUtils from '../../../utils/coreUtils.js';
import NodeEngine from '../nodeEngine.js';

export default class NodeCombineMeshes extends Node
{
	constructor(pParent)
	{
		super(pParent);

		this.addInput(PARAM_TYPE.GEOMETRY, 'geo', null);

		this.addOutput(PARAM_TYPE.SPLINE, 'geo');
	}

	getType()
	{
		return 'combineMeshes';
	}

	getDoAllowUserOutputFor(inputType)
	{
		// Disallow these since the input meshes are deleted and don't work correctly anymore
		return false;
	}

	getMergeCandidates(pStartMesh, pAllMeshes)
	{
		let resList = [];

		const pParent = this.getParent();

		const pStartCreationNode = pParent.getNode(pStartMesh.parentNodeId);
		const bIsStartFile = pStartCreationNode && pStartCreationNode.getType() === 'file';
		const startGeomId = bIsStartFile ? pStartCreationNode.getLastInputResult('file') : -1;

		let bMergeFileNodes = NodeEngine.getInstance().getEnableCombiningImportedMeshes();

		for(let mesh of pAllMeshes)
		{
			if(pStartMesh.overrideMaterialSideOrientation !== mesh.overrideMaterialSideOrientation)
				continue;

			if(!Utils3D.areMaterialsEqual(pStartMesh.material, mesh.material))
				continue;

			const pCurrCreationNode = pParent.getNode(mesh.parentNodeId);
			const bIsCurrFile = pCurrCreationNode && pCurrCreationNode.getType() === 'file';
			if(bIsCurrFile !== bIsStartFile && (bIsStartFile || bIsCurrFile))
				continue;

			if(bIsCurrFile && !bMergeFileNodes)
				continue;

			if(bIsStartFile)
			{
				const currGeomId = pCurrCreationNode.getLastInputResult('file');
				if(currGeomId !== startGeomId)
					continue;
			}

			// TODO: We're not handling the material tweaks

			resList.push(mesh);
		}

		if(resList.length === 0)
			resList = [pStartMesh];

		return resList;
	}

	generateSubclass(scene, inputValues, outputName, computedOutputResults)
	{	
		let pMeshesToMerge = [];
		let pInputs = this.getInputs();
		for(let pInput of pInputs)
		{
			if(!pInput.getConnectedNode())
				continue;

			const strName = pInput.getName();
			if(Array.isArray(inputValues[strName]))
				pMeshesToMerge = pMeshesToMerge.concat(inputValues[strName]);
			else if(inputValues[strName] !== null)
				pMeshesToMerge.push(inputValues[strName]);
		}

		const iNumInitMeshes = pMeshesToMerge.length;

		let otherMeshes = [];
		pMeshesToMerge.forEach((pMesh) => { 
			if(pMesh instanceof BABYLON.InstancedMesh)
				otherMeshes.push(pMesh);
		});

		pMeshesToMerge = pMeshesToMerge.filter((obj) => { return Utils.getIsMeshObject(obj) && !(obj instanceof BABYLON.InstancedMesh) && obj.geometry; });

		// Now, we need to only combine meshes that can be combined. For now, 
		// do it the simple way:
		let finalMeshes = [];
		while(pMeshesToMerge.length > 0)
		{
			let candidateList = this.getMergeCandidates(pMeshesToMerge[0], pMeshesToMerge);

			let resMesh = candidateList[0];
			if(candidateList.length > 1)
			{
				resMesh = BABYLON.Mesh.MergeMeshes(candidateList, true, true);
				Utils3D.cloneCustomAttributes(resMesh, candidateList[0]);
				this.onMeshCreated(resMesh);
			}
				
			finalMeshes.push(resMesh);

			let candidateIds = {};
			candidateList.forEach((mesh) => { candidateIds[mesh.uniqueId] = true; });
			pMeshesToMerge = pMeshesToMerge.filter((mesh) => { return !candidateIds[mesh.uniqueId]; });
		}

		finalMeshes = finalMeshes.concat(otherMeshes);
		// CoreUtils.log(`Combining meshes: from ${iNumInitMeshes} to  ${finalMeshes.length}`);
		return finalMeshes.length > 0 ? finalMeshes : null;
	}
}